export default "__VITE_ASSET__CUZYzPW3__"